import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-20'],
  },
  previewContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    background: colors.deepBackground,
    padding: '0 80px 40px 80px',
    zIndex: 20,
    overflow: 'auto',
  },
  previewHeader: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  previewTitle: {
    color: colors.primaryText,
    fontSize: typography['fontSizeHeading-3'],
    lineHeight: anatomy['size-36'],
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '200px 1fr',
    gap: anatomy['size-24'],
    minHeight: '600px',
  },
});
